import useChainInfo from "@/hooks/useChainInfo";
import type { Networkish, SupSingleVaultV3 } from "@/types";
import React, { Fragment } from "react";

import UiTooltip from "@/components/Ui/Tooltip";
import { getProtocolImage, getProtocolName, getVaultApy } from "@/utils";
import { SupChip, SupLoader, SupText } from "@repo/core-ui";
import { SupCoinAlt } from "@repo/core-ui";
import config from "@/../config/dapp.config";
import dictionaryConfig from "@/../config/dictionary.config";

interface UiChipVaultProps {
  singleVault: SupSingleVaultV3;
  chainId?: Networkish;
}
export default function UiChipVault({ singleVault, chainId }: UiChipVaultProps) {
  const { data: chainData, isLoading } = useChainInfo(chainId || singleVault.chain.id);

  return (
    <SupChip
      className="min-w-0"
      icon={singleVault.assets[0].image || <SupCoinAlt className="h-[38px] w-auto rounded-full stroke-0 object-cover" />}
      subIcon={isLoading ? <SupLoader isSmall /> : chainData?.icon}
      label={
        <UiTooltip enable={singleVault.friendly_name.length > 40} content={singleVault.friendly_name} arrowPlacement="top">
          <SupText variant="subtitle1" className="overflow-hidden text-ellipsis whitespace-nowrap">
            {singleVault.friendly_name}
          </SupText>
        </UiTooltip>
      }
      subLabel={
        <div className="mt-1 flex min-w-0 items-center gap-1">
          {singleVault.protocol && (
            <Fragment>
              <img className="h-4 w-4 shrink-0 rounded-full" src={getProtocolImage(singleVault)} alt={getProtocolName(singleVault)} />
              <SupText variant="caption" weight="bold" className="shrink-0">
                {getProtocolName(singleVault)}
              </SupText>
            </Fragment>
          )}
          {getVaultApy(singleVault) !== dictionaryConfig.statsDefaultValue && (
            <SupText as="div" variant="body2" className="overflow-hidden text-ellipsis whitespace-nowrap">
              {parseFloat(String(getVaultApy(singleVault))).toFixed(config.decimalsApyRoundingLimit)}%
            </SupText>
          )}
        </div>
      }
    />
  );
}
